import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const MultipleChoiceSingleIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M13.9997 2.83334C14.2758 2.83334 14.4997 3.0572 14.4997 3.33334C14.4997 3.60949 14.2758 3.83334 13.9997 3.83334H8.66666C8.39051 3.83334 8.16666 3.60949 8.16666 3.33334C8.16666 3.0572 8.39051 2.83334 8.66666 2.83334H13.9997Z"
      fill="currentColor"
    />
    <path
      d="M13.9997 7.5C14.2758 7.5 14.4997 7.72386 14.4997 8C14.4997 8.27614 14.2758 8.5 13.9997 8.5H8.66666C8.39051 8.5 8.16666 8.27614 8.16666 8C8.16666 7.72386 8.39051 7.5 8.66666 7.5H13.9997Z"
      fill="currentColor"
    />
    <path
      d="M13.9997 12.1667C14.2758 12.1667 14.4997 12.3905 14.4997 12.6667C14.4997 12.9428 14.2758 13.1667 13.9997 13.1667H8.66666C8.39051 13.1667 8.16666 12.9428 8.16666 12.6667C8.16666 12.3905 8.39051 12.1667 8.66666 12.1667H13.9997Z"
      fill="currentColor"
    />
    <path
      d="M5.64649 9.64648C5.84175 9.45121 6.15826 9.45121 6.35352 9.64648C6.54878 9.84174 6.54878 10.1582 6.35352 10.3535L3.68653 13.0205C3.49124 13.2154 3.17465 13.2157 2.9795 13.0205L1.64649 11.6865C1.45139 11.4912 1.45128 11.1747 1.64649 10.9795C1.84171 10.7844 2.1583 10.7844 2.35352 10.9795L3.33301 11.959L5.64649 9.64648Z"
      fill="currentColor"
    />
    <path
      d="M5.5 3.33365C5.5 3.2416 5.42506 3.16666 5.33301 3.16666H2.66699C2.57494 3.16666 2.5 3.2416 2.5 3.33365V5.99966C2.5 6.09171 2.57494 6.16666 2.66699 6.16666H5.33301C5.42506 6.16666 5.5 6.09171 5.5 5.99966V3.33365ZM6.5 5.99966C6.5 6.644 5.97734 7.16666 5.33301 7.16666H2.66699C2.02266 7.16666 1.5 6.644 1.5 5.99966V3.33365C1.5 2.68932 2.02266 2.16666 2.66699 2.16666H5.33301C5.97734 2.16666 6.5 2.68932 6.5 3.33365V5.99966Z"
      fill="currentColor"
    />
  </svg>
);
